import * as yup from "yup";
import { stringValidation, getStringValidationRequired } from "@/shared/yup";

export const connectionSchema = yup.object().shape({
  personId: getStringValidationRequired(),
  connection: stringValidation,
  additionalInfo: stringValidation,
  id: stringValidation,
});

export type ConnectionFormValues = yup.InferType<typeof connectionSchema>;
